import { render, staticRenderFns } from "./usertiantianyue.vue?vue&type=template&id=913ff758&scoped=true&"
import script from "./usertiantianyue.vue?vue&type=script&lang=js&"
export * from "./usertiantianyue.vue?vue&type=script&lang=js&"
import style0 from "./usertiantianyue.vue?vue&type=style&index=0&id=913ff758&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913ff758",
  null
  
)

export default component.exports